import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AdministrationCarrierVehicleService,
  AnyValueModelUUID,
  VehicleManualAddRequest,
  VehicleModel,
  VehiclePhotoType,
  VehicleCargoRequest,
  VehicleVinAndMakeRequest,
  VehicleRegistrationRequest
} from '../autogenerated';
import { REQUEST_OPTIONS } from '../constants';
import { RequestOptionsJsonType, RequestOptionsVoidType } from '../types';

@Injectable({ providedIn: 'root' })
export class AdministrationCarrierVehicleApiService {
  constructor(private apiService: AdministrationCarrierVehicleService) {}

  public addVehicle(carrierId: string, value: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AnyValueModelUUID> {
    return this.apiService.adminCarrierVehicleAdd(carrierId, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public addVehicleManual(carrierId: string, body: VehicleManualAddRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AnyValueModelUUID> {
    return this.apiService.adminCarrierVehicleAddManual(carrierId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public assignDriver(vehicleId: string, driverId: string, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.adminCarrierVehicleAssignDriver(vehicleId, driverId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public delete(vehicleId: string, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.adminCarrierVehicleDelete(vehicleId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public deleteVehiclePhoto(vehicleId: string, photoType: VehiclePhotoType, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<VehicleModel> {
    return this.apiService.adminCarrierVehicleDeletePhoto(vehicleId, photoType, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public deleteVehicleRegistration(vehicleId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<VehicleModel> {
    return this.apiService.adminCarrierVehicleDeleteRegistration(vehicleId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editVehicleCargo(vehicleId: string, body: VehicleCargoRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<VehicleModel> {
    return this.apiService.adminCarrierVehicleEditCargo(vehicleId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editVehicleMakeAndVin(vehicleId: string, body: VehicleVinAndMakeRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<VehicleModel> {
    return this.apiService.adminCarrierVehicleEditMakeAndVin(vehicleId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editVehiclePhoto(vehicleId: string, photoType: VehiclePhotoType, value: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<VehicleModel> {
    return this.apiService.adminCarrierVehicleEditPhoto(vehicleId, photoType, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editVehiclePlate(vehicleId: string, value: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<VehicleModel> {
    return this.apiService.adminCarrierVehicleEditPlate(vehicleId, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editVehiclePrimaryPhoto(vehicleId: string, photoType: VehiclePhotoType, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<VehicleModel> {
    return this.apiService.adminCarrierVehicleEditPrimaryPhoto(vehicleId, photoType, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editVehicleRegistration(vehicleId: string, body: VehicleRegistrationRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<VehicleModel> {
    return this.apiService.adminCarrierVehicleEditRegistration(vehicleId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editVehicleTag(vehicleId: string, value: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<VehicleModel> {
    return this.apiService.adminCarrierVehicleEditTag(vehicleId, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editVehicleVerified(vehicleId: string, verified: boolean, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<VehicleModel> {
    return this.apiService.adminCarrierVehicleEditVerified(vehicleId, verified, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public vehicle(vehicleId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<VehicleModel> {
    return this.apiService.adminCarrierVehicleGet(vehicleId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public unassignDriver(vehicleId: string, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.adminCarrierVehicleUnassignDriver(vehicleId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
